import { axiosInstance } from '../../utils';
import { IAudioCreation } from '../../@types';

interface Payload {
  text: string;
  audioId: string;
  name: string;
}

export const saveAudio = async (payload: Payload): Promise<IAudioCreation> => {
  const res = await axiosInstance.post('/api/audios/audio-build', payload);
  return res.data;
};
